import { render, staticRenderFns } from "./siderbar.vue?vue&type=template&id=36237da4&scoped=true"
import script from "./siderbar.vue?vue&type=script&lang=js"
export * from "./siderbar.vue?vue&type=script&lang=js"
import style0 from "./siderbar.vue?vue&type=style&index=0&id=36237da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36237da4",
  null
  
)

export default component.exports